@if (cropField() && !isLoading()) {
  <specific-form-header-section
    [title]="'TGA.Advice.Cultivation.Title' | translate"
    [cropYear]="cropYear"
    [cropField]="cropField()!"
  ></specific-form-header-section>

  <app-advice-card [title]="'blightV2.advice.title' | translate" class="container">
    @if (isMobile) {
      <app-blight-dashboard-widget [tgaCropfieldId]="cropFieldId" [isTga]="true" />
    } @else {
      <app-blight-insight-page
        [disableCropFieldSelector]="true"
        [preselectedCropFieldId]="cropFieldId"
      ></app-blight-insight-page>
    }
  </app-advice-card>

  <div class="cultivation-widgets-row">
    <div class="bem-widget-container">
      <app-crop-soil-analysis-block
        [cropSoilAnalysisData$]="cropSoilAnalysisData$"
        displayMode="tga"
        [isParticipatingInBem]="cropField()?.isParticipatingToBem ?? false"
        (adviceButtonClick)="navigateToBem()"
      ></app-crop-soil-analysis-block>
    </div>

    <div class="biomass-benchmark-container">
      <app-biomass-benchmark-widget [dataState]="biomassBenchmarkState()" [cropFieldName]="cropField()?.name ?? null" />
    </div>
  </div>

  <div class="field-observation-container">
    <app-tga-field-observation-images
      [fieldObservationImages$]="fieldObservationImages$"
      [cropFieldId]="cropFieldId"
      [cropFieldName]="cropField()?.name ?? ''"
    />
  </div>

  <!-- Satellite Images -->
  <div class="satellite-container">
    <app-tga-satellite-images
      [satelliteImages$]="satelliteImages$"
      [cropFieldId]="cropFieldId"
      [cropFieldName]="cropField()?.name ?? ''"
      (dateRangeChanged)="onSatelliteImageDateRangeChange($event)"
    />
  </div>

  <app-risk-analysis [translationParams]="translationParams()" [adviceLines]="cultivationAdvice()"></app-risk-analysis>
} @else if (isLoading()) {
  <div class="loading-container">
    <app-loading-card [loadingText]="'BFP.UI.Loading'" />
  </div>
}
